export type KnownSocialPlatform = 'douyin' | 'kuaishou' | 'tiktok' | 'xiaohongshu' | 'instagram';

const SOCIAL_PLATFORM_ALIASES: Record<string, KnownSocialPlatform> = {
  douyin: 'douyin',
  DOUYIN: 'douyin',
  抖音: 'douyin',
  kuaishou: 'kuaishou',
  KUAISHOU: 'kuaishou',
  快手: 'kuaishou',
  tiktok: 'tiktok',
  TIKTOK: 'tiktok',
  TikTok: 'tiktok',
  Tiktok: 'tiktok',
  xiaohongshu: 'xiaohongshu',
  XIAOHONGSHU: 'xiaohongshu',
  xhs: 'xiaohongshu',
  XHS: 'xiaohongshu',
  小红书: 'xiaohongshu',
  instagram: 'instagram',
  INSTAGRAM: 'instagram',
  ins: 'instagram',
  INS: 'instagram',
  Instagram: 'instagram',
};

// 统一收口业务里常见的平台中英文别名，避免不同接口字段直接在页面里分散判断。
export function normalizeSocialPlatform(platform?: string | null): KnownSocialPlatform | undefined {
  if (!platform) {
    return undefined;
  }

  const trimmedPlatform = platform.trim();
  if (!trimmedPlatform) {
    return undefined;
  }

  return SOCIAL_PLATFORM_ALIASES[trimmedPlatform] || SOCIAL_PLATFORM_ALIASES[trimmedPlatform.toLowerCase()];
}
